import { render } from "./stopUsing.vue?vue&type=template&id=2de085bf&scoped=true&ts=true"
import script from "./stopUsing.vue?vue&type=script&lang=ts"
export * from "./stopUsing.vue?vue&type=script&lang=ts"

import "./stopUsing.vue?vue&type=style&index=0&id=2de085bf&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de085bf"]])

export default __exports__